@if (canSearch()) {
  <!-- Sotto 992px il campo inline lascia il posto a un'icona: la ricerca si apre in overlay. -->
  <span class="min-[992px]:hidden">
    <button type="button" class="header-action header-action-icon"
      [attr.aria-expanded]="mobileOpen()" aria-controls="header-site-search" aria-haspopup="true"
      title="Cerca frazionario" aria-label="Cerca frazionario" (click)="openMobileSearch()">
      <fa-icon [icon]="['fas', 'search']" aria-hidden="true"></fa-icon>
    </button>
  </span>

  <div class="site-search min-[992px]:w-[min(24rem,38vw)] min-[992px]:min-w-[14rem]" [class.is-mobile-open]="mobileOpen()">
    @if (mobileOpen()) {
      <button type="button" class="mr-2 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white hover:bg-white/15 min-[992px]:hidden"
        title="Chiudi ricerca" aria-label="Chiudi ricerca" (click)="closeMobileSearch()">
        <fa-icon [icon]="['fas', 'arrow-left']" aria-hidden="true"></fa-icon>
      </button>
    }

    <div class="flex h-8 min-w-0 flex-1 items-center gap-2 rounded-lg border border-white/15 bg-white/10 px-2.5 text-white transition-colors focus-within:border-white/40 focus-within:bg-white/15">
      <fa-icon [icon]="['fas', 'search']" class="shrink-0 text-xs text-white/70" aria-hidden="true"></fa-icon>
      <label class="sr-only" for="header-site-search">Cerca frazionario e apri la scheda sede</label>
      <input #searchInput id="header-site-search" type="search" autocomplete="off" spellcheck="false"
        class="h-full w-full min-w-0 bg-transparent text-sm text-white placeholder:text-white/60 focus:outline-none"
        placeholder="Cerca frazionario…" role="combobox" aria-autocomplete="list"
        aria-controls="header-site-search-list" [attr.aria-expanded]="open()"
        [ngModel]="query()" (ngModelChange)="onQueryChange($event)"
        (focus)="onFocus()" (keydown)="onKeydown($event)" />
      @if (loading()) {
        <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="shrink-0 text-xs text-white/70" aria-hidden="true"></fa-icon>
      } @else if (query()) {
        <button type="button" class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded text-white/70 hover:bg-white/15 hover:text-white"
          title="Cancella ricerca" aria-label="Cancella ricerca" (click)="clear()">
          <fa-icon [icon]="['fas', 'xmark']" aria-hidden="true"></fa-icon>
        </button>
      }
    </div>

    @if (open()) {
      <div id="header-site-search-list" role="listbox" aria-label="Frazionari"
        class="absolute left-0 top-full z-[1100] mt-2 w-[26rem] max-w-[calc(100vw-2rem)] overflow-hidden rounded-xl border border-fq-border-soft bg-fq-surface text-fq-text shadow-2xl max-[991px]:left-3 max-[991px]:right-3 max-[991px]:w-auto">
        @if (loading()) {
          <div class="px-4 py-6 text-center text-xs text-fq-text-muted">
            <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="mr-1.5" aria-hidden="true"></fa-icon>
            Caricamento sedi…
          </div>
        } @else if (loadError()) {
          <div class="px-4 py-6 text-center text-xs text-fq-text-muted">
            Anagrafica sedi non disponibile. Riprova più tardi.
          </div>
        } @else if (results().length === 0) {
          <div class="px-4 py-6 text-center text-xs text-fq-text-muted">
            Nessuna sede trovata per “{{ query() }}”.
          </div>
        } @else {
          <div class="max-h-[60vh] overflow-y-auto py-1">
            @for (site of results(); track site.fraz; let index = $index) {
              <button type="button" role="option" [attr.aria-selected]="index === activeIndex()"
                class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-fq-surface-muted"
                [class.bg-fq-surface-muted]="index === activeIndex()"
                (mouseenter)="activeIndex.set(index)" (click)="openSite(site)">
                <span class="fq-badge fq-badge-primary shrink-0">{{ site.fraz }}</span>
                <span class="min-w-0 flex-1 truncate text-fq-text-2">{{ site.label || '—' }}</span>
                <fa-icon [icon]="['fas', 'location-dot']" class="shrink-0 text-[11px] text-fq-text-muted" aria-hidden="true"></fa-icon>
              </button>
            }
          </div>
          <div class="border-t border-fq-border-faint px-3 py-1.5 text-[11px] text-fq-text-muted">
            Invio per aprire la scheda sede
          </div>
        }
      </div>
    }
  </div>
}

<p-dialog [visible]="dialogVisible()" (visibleChange)="dialogVisible.set($event)"
  [header]="'Scheda sede ' + (selectedFraz() || '')" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(1280px, 97vw)', 'max-height': '92vh' }"
  [contentStyle]="{ 'max-height': '78vh', 'overflow-y': 'auto' }" [baseZIndex]="2200" appendTo="body">
  @if (dialogVisible() && selectedFraz()) {
    <app-site-hub [frazInput]="selectedFraz()" [embedded]="true"></app-site-hub>
  }
</p-dialog>
